import { roomCurrent, roomClean } from 'network/ApiAccomodation';
import React,{useState,useEffect} from 'react'
import { Button, Modal, ModalHeader, ModalBody, ModalFooter,Row,Col } from 'reactstrap';
import {ddns} from '../../../../../package.json'
import RoomLogs from './RoomLogs';

function RoomModal(props) {
    const [roomInfo, setRoomInfo] = useState();
    
    useEffect(() => {
        getRoomCurrent()
    }, []);

    const getRoomCurrent = async()=>{
        const resp = await roomCurrent(props.area._id)
        if(resp.data.success){
            setRoomInfo(resp.data.roomInfo)
        }
    }
    console.log(roomInfo)

    const roomInUse = ()=>{
        return( 
            <>
                <Row>
                    <Col>
                        <div className="card-profile-image mb-6">                        
                            <img 
                                alt="..." 
                                className="rounded-circle" 
                                src={roomInfo.userId.picture 
                                    ? ddns + '/userfiles/' + roomInfo.userId.email + '/pics/' + roomInfo.userId.picture 
                                    : require("assets/img/theme/team-1-800x800.jpg").default} 
                            />                    
                        </div>
                    </Col>
                </Row>
                <Row className='d-flex justify-content-center mt-6' >
                    <h3 >{roomInfo.userId.name ? roomInfo.userId.name : roomInfo.userName}</h3>
                </Row>
                <Row>
                    <Col>
                        Deposit: {roomInfo.deposit 
                        ? <span style={{height: '25px',width: '25px', backgroundColor: 'green', borderRadius: '50%', display: 'inline-block'}}></span>
                        : <span style={{height: '25px',width: '25px', backgroundColor: 'red', borderRadius: '50%', display: 'inline-block'}}></span>}
                    </Col>
                    <Col>
                        Rent: {roomInfo.rent}
                    </Col>
                </Row>
            </>
        )
    }

    const roomNotInUse = ()=>{
        return( 
            <>
                <Row>
                    <h1>Room Empty</h1>
                </Row>
                <Row>
                    Room Clean: {roomInfo.clean 
                            ? <span style={{height: '25px',width: '25px', backgroundColor: 'green', borderRadius: '50%', display: 'inline-block'}}></span>
                            : <span style={{height: '25px',width: '25px', backgroundColor: 'red', borderRadius: '50%', display: 'inline-block'}}></span>}
                </Row>
            </>
        )
    }

    const handleMarkCleaned = async()=>{
        console.log(roomInfo._id)
        const resp = await roomClean(roomInfo._id)
        if(resp.data.success){
            props.mapReload(roomInfo._id)
            props.toggle()
        }else{
            alert('something went wrong')
        }
    }

    const handleCheckIn = async()=>{
        props.toggle()
        props.inToggle()
    }

    const handleCheckOut = async()=>{
        props.toggle()
        props.outToggle()
    }

    return (
        <>
        <Modal isOpen={props.modal} toggle={props.toggle}>
            <ModalHeader>
                {props.area.title}
            </ModalHeader>
            {roomInfo &&
                <ModalBody className='ml-2'>
                    {props.area.inUse ? roomInUse() : roomNotInUse()}
                </ModalBody>
            }
            <ModalFooter>
                <Row>
                    <Col>
                        {!props.area.clean && <Button className='btn-info' onClick={handleMarkCleaned} >Mark Cleaned</Button>}
                    </Col>
                    <Col>
                        {!props.area.inUse && <Button className='btn-success' onClick={handleCheckIn} >Check In</Button>}
                    </Col>
                    <Col>
                        {props.area.inUse && <Button className='btn-danger' onClick={handleCheckOut} >Check Out</Button>}
                    </Col>
                </Row>
            </ModalFooter>
            {/* render room logs here */}
            <RoomLogs roomId={props.area._id}/>
        </Modal>
        
        </>
  )
}

export default RoomModal